define('components/course/models/base',[
    'components/boilerplate/models/base',
    'components/utils/models/guid'
], function (Base, Guid) {
    "use strict";

    return Base.extend({
        "authoringJSONKey": function () {
            return {
                "_id": null,
                "parentId": null,
                "title": null
            };
        },

        "saveStateJSONKey": function () {
            return {
                "_id": null
            };
        }
    });
});

